(function() {
  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function getSelectedColorValue(mediaGallery) {
    var colorOptionName = mediaGallery.getAttribute('data-color-option-name');
    var colorOptionPosition = mediaGallery.getAttribute('data-color-option-position');
    var section = mediaGallery.closest('.shopify-section');

    if (!section || !colorOptionName) {
      return '';
    }

    var checkedInputs = section.querySelectorAll('input[type="radio"]:checked');

    for (var i = 0; i < checkedInputs.length; i++) {
      var input = checkedInputs[i];
      var inputName = input.getAttribute('name') || '';

      if (
        inputName === colorOptionName + '-' + colorOptionPosition ||
        inputName.indexOf(colorOptionName + '-') === 0 ||
        inputName.toLowerCase().indexOf(colorOptionName.toLowerCase()) === 0
      ) {
        return input.value;
      }
    }

    var selects = section.querySelectorAll('select');

    for (var j = 0; j < selects.length; j++) {
      var selectName = selects[j].getAttribute('name') || '';

      if (
        selectName === 'options[' + colorOptionName + ']' ||
        selectName.toLowerCase().indexOf(colorOptionName.toLowerCase()) !== -1
      ) {
        return selects[j].value;
      }
    }

    return '';
  }

  function filterGallery(mediaGallery) {
    if (!mediaGallery) {
      return;
    }

    var sectionId = mediaGallery.id.replace('MediaGallery-', '');
    var selectedColor = normalize(getSelectedColorValue(mediaGallery));

    var mediaItems = mediaGallery.querySelectorAll(
      '#Slider-Gallery-' + sectionId + ' .product__media-item'
    );

    var thumbnailItems = mediaGallery.querySelectorAll(
      '#Slider-Thumbnails-' + sectionId + ' .thumbnail-list__item'
    );

    var firstVisibleMedia = null;
    var firstVisibleThumbButton = null;

    for (var i = 0; i < mediaItems.length; i++) {
      var mediaColor = normalize(mediaItems[i].getAttribute('data-media-color'));
      var showMedia = !selectedColor || mediaColor === selectedColor;

      if (showMedia) {
        mediaItems[i].classList.remove('ktn-media-hidden');
        if (!firstVisibleMedia) {
          firstVisibleMedia = mediaItems[i];
        }
      } else {
        mediaItems[i].classList.add('ktn-media-hidden');
        mediaItems[i].classList.remove('is-active');
      }
    }

    for (var j = 0; j < thumbnailItems.length; j++) {
      var thumbColor = normalize(thumbnailItems[j].getAttribute('data-media-color'));
      var showThumb = !selectedColor || thumbColor === selectedColor;
      var thumbButton = thumbnailItems[j].querySelector('button.thumbnail');

      if (showThumb) {
        thumbnailItems[j].classList.remove('ktn-media-hidden');
        if (!firstVisibleThumbButton && thumbButton) {
          firstVisibleThumbButton = thumbButton;
        }
      } else {
        thumbnailItems[j].classList.add('ktn-media-hidden');
        if (thumbButton) {
          thumbButton.removeAttribute('aria-current');
        }
      }
    }

    mediaGallery.querySelectorAll('.product__media-item.is-active').forEach(function(item) {
      item.classList.remove('is-active');
    });

    if (firstVisibleMedia) {
      firstVisibleMedia.classList.add('is-active');
    }

    mediaGallery.querySelectorAll('.thumbnail[aria-current="true"]').forEach(function(button) {
      button.removeAttribute('aria-current');
    });

    if (firstVisibleThumbButton) {
      firstVisibleThumbButton.setAttribute('aria-current', 'true');
    }

    var currentEl = mediaGallery.querySelector('.slider-counter--current');
    var totalEl = mediaGallery.querySelector('.slider-counter--total');

    if (currentEl) {
      currentEl.textContent = firstVisibleMedia ? '1' : '0';
    }

    if (totalEl) {
      var visibleCount = mediaGallery.querySelectorAll(
        '#Slider-Gallery-' + sectionId + ' .product__media-item:not(.ktn-media-hidden)'
      ).length;
      totalEl.textContent = visibleCount;
    }
  }

  function initGalleryFilters(scope) {
    var root = scope || document;
    var galleries = root.querySelectorAll('media-gallery[data-color-option-name]');

    for (var i = 0; i < galleries.length; i++) {
      filterGallery(galleries[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initGalleryFilters(document);
  });

  document.addEventListener('change', function(event) {
    var section = event.target.closest('.shopify-section');

    if (!section) {
      return;
    }

    var mediaGallery = section.querySelector('media-gallery[data-color-option-name]');

    if (!mediaGallery) {
      return;
    }

    setTimeout(function() {
      filterGallery(mediaGallery);
    }, 0);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initGalleryFilters(event.target);
  });
})();